<template>
  <ButtonBase
    :theme="theme"
    stroke="n"
    class="button"
    :disabled="playAction"
    rounded
    size="small"
    :to="path"
    @click="handleAction"
  >
    {{ action.label }}
  </ButtonBase>
</template>
<script setup lang="ts">
interface Props {
  feed: FeedSchema;
  action: FeedActionSchema;
}
const props = defineProps({
  feed: null,
  action: null
});
const playAction = ref<boolean>(false);
const theme = computed(() => {
  return props.action.type === 'confirm' ? 'secondary' : 'secondary-light';
});

const dialog = useDialogStore();

const path = computed(() => {
  return props.action?.deeplinkRedirect?.path || null;
});

const redirectToDeeplink = async (deeplink: string) => {
  const { path } = await useDeepLinkParser(deeplink);
  if (path) {
    navigateTo(path, {
      external: path.includes('hhtp'),
    });
  }
};

const handleAction = async () => {
  playAction.value = true;
  useAppEventFeed(EventFeed.ActionClicked, props.feed.id, {
    ActionId: props.action.id,
  });
  if (!props.action.deeplink) {
    const { result } = await useFeedPostAction(
      props.feed.id,
      props.action.adamActionParameters || {}
    );
    if (result && result.deeplink) {
      await redirectToDeeplink(result.deeplink);

      dialog.close();
    }
  }
  if (!props.feed.read) {
    await useFeedPostReadIds([props.feed.id]);
  } else if (props.action.needRefresh) {
    await useFeedLoadFromNetwork();
  }
  playAction.value = false;
};
</script>
